import Dialog from "@hyro-components/Dialog";
import React from "react";
import { BULK_ACTIONS_TYPES, BULK_ACTIONS_DIALOG_DATA } from "./BulkActions.consts";

const BulkActionsDialog = ({
  open,
  actionType = BULK_ACTIONS_TYPES.DELETE,
  rowsCount = 0,
  onConfirm,
  onCancel
}) => {
  const pluralSuffix = rowsCount !== 1 ? "s" : "";
  const isDelete = actionType === BULK_ACTIONS_TYPES.DELETE;

  const title = isDelete
    ? BULK_ACTIONS_DIALOG_DATA.DELETE.title(rowsCount, pluralSuffix)
    : BULK_ACTIONS_DIALOG_DATA.DUPLICATE.title(rowsCount, pluralSuffix);

  const content = isDelete
    ? BULK_ACTIONS_DIALOG_DATA.DELETE.content(rowsCount, pluralSuffix)
    : BULK_ACTIONS_DIALOG_DATA.DUPLICATE.content(rowsCount, pluralSuffix);

  const submitButtonText = isDelete ? BULK_ACTIONS_DIALOG_DATA.DELETE.submitButtonText : BULK_ACTIONS_DIALOG_DATA.DUPLICATE.submitButtonText;
  const confirmColor = isDelete ? BULK_ACTIONS_DIALOG_DATA.DELETE.confirmColor : BULK_ACTIONS_DIALOG_DATA.DUPLICATE.confirmColor;

  return (
    <Dialog
      testId={"bulk-actions"}
      open={open}
      variant="transactional"
      onClose={onCancel}
      title={title}
      handleSubmit={onConfirm}
      handleCancel={onCancel}
      submitButtonText={submitButtonText}
      confirmColor={confirmColor}
    >
      {content}
    </Dialog>
  );
};

export default BulkActionsDialog;
